var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image__preview__model",on:{"click":_vm.onClose}},[_c('div',{staticClass:"image__preview__container"},[_c('img',{attrs:{"src":_vm.hdImage}})])])}
var staticRenderFns = []

export { render, staticRenderFns }